import {Component, Input, OnInit} from "@angular/core";


@Component({
  selector: 'int-tooltip',
  templateUrl: 'int-tooltip.component.html',
  styleUrls: ['int-tooltip.component.scss']
})
export class IntTooltipComponent implements OnInit {
  @Input() content = '';
  @Input() position = 'center';
  @Input() zIndex = 100;
  @Input() width = 'auto';
  constructor() {
  }

  get contentPosition(): string {
    return `tooltip__content--${this.position}`
  }
  ngOnInit() {
  }
}
